import { isValidEmail } from "client/utils/validator";

export const getEmailFromUrlParams = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  const emailParam = urlParams.get("email") || "";
  return isValidEmail(emailParam) ? emailParam : "";
};

export const removeSearchParamsFromUrlString = (
  url: string,
  param: string
): string => {
  try {
    const urlObj = new URL(url);
    if (urlObj.searchParams && urlObj.searchParams.has(param)) {
      urlObj.searchParams.delete(param);
      return urlObj.href;
    }
    return url;
  } catch (error) {
    console.error(`Invalid url provided: ${error}`);
  }
  return "";
};
